import { FontEntry } from '../../types/font'

export const poppins: FontEntry = {
  displayName: 'Poppins',
  weights: {
    400: {
      normal: { file: 'Poppins-Regular', extension: 'ttf', format: 'truetype' },
      italic: null
    },
    600: {
      normal: { file: 'Poppins-SemiBold', extension: 'ttf', format: 'truetype' },
      italic: null
    },
    700: { normal: { file: 'Poppins-Bold', extension: 'ttf', format: 'truetype' }, italic: null }
  }
}
